// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/spend_management/memberships/bank_details/firstparty/v3/update_bank_details.proto

/* oxlint-disable */
import { ApiMembershipBankDetails } from "./bank_details";

/** Input shape matching { "membership_bank_details": { "iban": "..." } } request body. */
export interface ApiUpdateBankDetailsInput {
  /** The new IBAN to associate with the membership. */
  readonly iban: string;
}

/** Request message for UpdateBankDetails. */
export interface ApiUpdateBankDetailsRequest {
  /** The ID of the membership (path parameter). */
  readonly id: string;
  /** The bank details input. */
  readonly membershipBankDetails: ApiUpdateBankDetailsInput | null;
}

/** Response message for UpdateBankDetails. */
export interface ApiUpdateBankDetailsResponse {
  /** The updated bank details. */
  readonly membershipBankDetails: ApiMembershipBankDetails | null;
}

export const ApiUpdateBankDetailsInput: MessageFns<ApiUpdateBankDetailsInput> = {
  fromJSON(object: any): ApiUpdateBankDetailsInput {
    return { iban: isSet(object.iban) ? globalThis.String(object.iban) : "" };
  },

  toJSON(message: ApiUpdateBankDetailsInput): unknown {
    const obj: any = {};
    if (message.iban !== undefined && message.iban !== null) {
      obj.iban = message.iban;
    }
    return obj;
  },
};

export const ApiUpdateBankDetailsRequest: MessageFns<ApiUpdateBankDetailsRequest> = {
  fromJSON(object: any): ApiUpdateBankDetailsRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      membershipBankDetails: isSet(object.membershipBankDetails)
        ? ApiUpdateBankDetailsInput.fromJSON(object.membershipBankDetails)
        : null,
    };
  },

  toJSON(message: ApiUpdateBankDetailsRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.membershipBankDetails !== undefined && message.membershipBankDetails !== null) {
      obj.membershipBankDetails = ApiUpdateBankDetailsInput.toJSON(message.membershipBankDetails);
    }
    return obj;
  },
};

export const ApiUpdateBankDetailsResponse: MessageFns<ApiUpdateBankDetailsResponse> = {
  fromJSON(object: any): ApiUpdateBankDetailsResponse {
    return {
      membershipBankDetails: isSet(object.membershipBankDetails)
        ? ApiMembershipBankDetails.fromJSON(object.membershipBankDetails)
        : null,
    };
  },

  toJSON(message: ApiUpdateBankDetailsResponse): unknown {
    const obj: any = {};
    if (message.membershipBankDetails !== undefined && message.membershipBankDetails !== null) {
      obj.membershipBankDetails = ApiMembershipBankDetails.toJSON(message.membershipBankDetails);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
